import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./AccordionItem.css";

export default class AccordionItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: this.props.isOpen };
    this.handleClick = this._handleClick.bind(this);
  }

  _handleClick() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    return (
      <div
        className={classNames(styles.root, {
          [styles.isOpen]: this.state.isOpen,
        })}
      >
        <button onClick={this.handleClick} className={styles.button}>
          {this.props.title}
        </button>
        <div className={styles.body}>{this.props.children}</div>
      </div>
    );
  }
}

AccordionItem.defaultProps = {
  isOpen: false,
};

AccordionItem.propTypes = {
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};
